import * as THREE from 'three'

export default class Hotspots {
    constructor() {
        this.zonas = [
            //Zonas sociales   
            // {
            //     position: new THREE.Vector3(-0.7, 0.84, -2.4),
            //     element: document.querySelector('.hotspot-0'),
            //     label: 'Terraza',
            //     img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/terraza.jpg'
            // },
           //No se está usando en este proyecto

        ]
        this.cercanias = [
            //Cercanias        
            {
                position: new THREE.Vector3(-1, 0.34, -25),
                element: document.querySelector('.hotspot-9')//Colegio Agustiniano
            },
            

            //Vias
            {
                position: new THREE.Vector3(-1, 0.2, -21),
                element: document.querySelector('.hotspot-18')//Av. Pepe Sierra
            },
            
        ]
    }
}



